'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Image } from '@/components/ui/Image';
import { TypographyBlockquote } from '@/components/ui/typography';
import { URLS } from '@/lib/consts';
import { cls } from '@/lib/utils';
import SectionBase from '../section-base';
import {
  buttonMotionProps as buttonMotionProperties,
  wrapperElementMotionProps as wrapperElementMotionProperties,
} from './animations';
import {
  QUOTE,
  COLLAGE_IMAGE_TEAM,
  COLLAGE_IMAGE_FAMILY,
  COLLAGE_IMAGE_PORTRAIT,
} from './consts';

const SECTION_ID = 'our-team';

function OurTeamSection() {
  return (
    <SectionBase
      id={SECTION_ID}
      containerProps={{ id: SECTION_ID }}
      background="bg-background"
    >
      <motion.div
        className={cls`flex flex-col md:flex-row gap-8 md:gap-12 items-center`}
        {...wrapperElementMotionProperties}
      >
        {/* Left: Photo Collage */}
        <div className="flex-1 w-full">
          <div className="flex gap-3">
            {/* Left column: 2 stacked photos (taller) */}
            <div className="flex flex-col gap-3 flex-1">
              <Image
                src={COLLAGE_IMAGE_TEAM}
                alt="Craig Hays, founder of Cornerstone Homes"
                fill
                sizes="(max-width: 768px) 50vw, 25vw"
                className="rounded-lg object-cover"
                wrapperClassName="aspect-2/3 relative"
                style={{ objectFit: 'cover', aspectRatio: '2/3' }}
              />
              <Image
                src={COLLAGE_IMAGE_FAMILY}
                alt="Julie Hays, co-founder of Cornerstone Homes"
                fill
                sizes="(max-width: 768px) 50vw, 25vw"
                className="rounded-lg object-cover"
                wrapperClassName="aspect-2/3 relative"
                style={{ objectFit: 'cover', aspectRatio: '2/3' }}
              />
            </div>

            {/* Right column: Portrait (same height as one left photo, centered vertically) */}
            <div className="flex items-center flex-1 self-center">
              <Image
                src={COLLAGE_IMAGE_PORTRAIT}
                alt="Abby Cook, lead designer at Cornerstone Homes"
                fill
                sizes="(max-width: 768px) 50vw, 25vw"
                className="rounded-lg object-cover"
                wrapperClassName="aspect-2/3 relative w-full h-auto"
                style={{ objectFit: 'cover', aspectRatio: '2/3' }}
              />
            </div>
          </div>
        </div>

        {/* Right: Quote + CTA */}
        <div className="flex-1 flex flex-col items-center md:items-start gap-8">
          <TypographyBlockquote className="border-l-0 text-center md:text-left font-prata text-xl sm:text-2xl lg:text-3xl leading-relaxed text-muted-foreground mt-0 pl-0 not-italic">
            {QUOTE}
          </TypographyBlockquote>

          <Button asChild>
            <motion.a
              {...buttonMotionProperties}
              href={URLS.REQUEST_CONSULTATION}
            >
              Contact Us
            </motion.a>
          </Button>
        </div>
      </motion.div>
    </SectionBase>
  );
}

export default OurTeamSection;
